// Slow editorial marquee. CSS-driven, pauses gracefully under reduced motion.
export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div
      className={`fs-marquee relative flex overflow-hidden border-y border-fs-border py-6 ${className}`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex shrink-0 animate-marquee items-center gap-10 pr-10 motion-reduce:animate-none">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-serif text-2xl font-light italic text-fs-ink/70 sm:text-3xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-fs-gold/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
